var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Chevron Down Circle"),React.createElement("path",{"d":"M464 256c0-114.87-93.13-208-208-208S48 141.13 48 256s93.13 208 208 208 208-93.13 208-208zm-100.69-28.69l-96 96a16 16 0 01-22.62 0l-96-96a16 16 0 0122.62-22.62L256 289.37l84.69-84.68a16 16 0 0122.62 22.62z","key":1})]);
}

Chevron.defaultProps = {"className":"ionicon","viewBox":"0 0 512 512"};

module.exports = Chevron;

Chevron.default = Chevron;
